import React from 'react';
import PropTypes from 'prop-types';
import { CardTitle, Typography } from '@one-thd/sui-atomic-components';
import { BuyingGuide } from '@one-thd/sui-icons';
import { getProjectsHeaderActionMap } from './actions';

const ProjectsHeader = ({ projectCount, actions, componentId }) => {

  const safeProjectCount = Number.isFinite(projectCount) ? projectCount : 0;
  const hasProjects = safeProjectCount > 0;

  const actionMap = getProjectsHeaderActionMap({ hasProjects, componentId });

  // Filter out invalid actions and prepare the rendered actions with separators
  const validActions = actions.filter((action) => Object.prototype.hasOwnProperty.call(actionMap, action));
  const renderedActions = validActions.length > 0 ? (
    <div className="sui-flex sui-gap-2">
      {validActions.map((action, index) => (
        <div key={`action-${action}-${index}`} className="sui-flex sui-items-center">
          {actionMap[action]}
          {index < validActions.length - 1 && (
            <div className="sui-ml-2">|</div>
          )}
        </div>
      ))}
    </div>
  ) : null;

  return (
    <div
      className="sui-pb-2 @sm:sui-pb-4 sui-pt-1"
    >
      <CardTitle
        header={(
          <div className="sui-flex sui-gap-3 sui-items-center">
            <BuyingGuide />
            <div className="sui-flex sui-gap-2 sui-items-center">
              <Typography variant="h4" weight="display">
                Projects
              </Typography>
              {projectCount > 0 && (
                <Typography variant="body-base">
                  {/* Add locale-aware thousands separators to project count. (e.g., 1,234) */}
                  ({projectCount.toLocaleString()})
                </Typography>
              )}
            </div>
          </div>
        )}
        data-test-id="projects-header"
        actionPosition="end"
        action={renderedActions}
      />
    </div>
  );
};

ProjectsHeader.propTypes = {
  projectCount: PropTypes.number,
  actions: PropTypes.arrayOf(PropTypes.oneOf(['learnMore', 'createNew', 'viewAll'])),
  componentId: PropTypes.string,
};

ProjectsHeader.defaultProps = {
  projectCount: 0,
  actions: [],
  componentId: '',
};

export default ProjectsHeader;
